import { useEffect, useState } from "react";
import { fetchDataFrom } from "../../_helper/fetcher";
import { makeItSelectable } from "../../_helper/helper";

const useLocations = (location) => {
  const [locations, setLocations] = useState([]);
  useEffect(() => {
    fetchDataFrom(location + "?limit=1000").then((data) => {
      if (!data.error) setLocations(makeItSelectable(data.data));
    });
  }, [location]);
  return locations;
};

export default useLocations;
